export const DOCUMENT_LIBRARY_COPY = {
	title: {
		add: 'Add document library',
		edit: 'Edit document library',
	},
	submit: {
		add: 'Add',
		edit: 'Save',
	},
	description:
		'Map the repositories where controlled procedures, forms, and training records live.',
	fields: {
		systemLabel: 'Which system stores this controlled library?',
		scopeLabel: 'What type of documents live here?',
		locationLabel: 'Where can someone access this library?',
	},
	actions: {
		removeConfirmTitle: 'Remove this document library?',
		removeConfirmDescription:
			'This library will be removed from the plan. You can add it again later.',
	},
	summary: {
		locationMissing: 'Location details missing.',
	},
}
